import classNames from 'classnames'

import type { CSSProperties, ReactElement } from 'react'

import image from '~/assets/rotating-logo-image.webp'

import './styles.scss'

interface Props {
  className?: string
  size: number
  styles?: CSSProperties
}

/** It has a single occurrence: on the home screen, where it is square-shaped. Its size in pixels is customisable. */
const RotatingLogo = ({ className, size, styles }: Props): ReactElement => {
  const wrapperStyle: CSSProperties = { height: `${size}px` }
  const imageStyle: CSSProperties = { height: `${size * 3.2}px`, left: `${size / -2}px`, ...styles }

  return (
    <div className={classNames('rotating-logo-component', className)} style={wrapperStyle}>
      <img
        alt="Continuously rotating company logo"
        className="rotating-logo-component__image"
        src={image}
        style={imageStyle}
      />
    </div>
  )
}

export default RotatingLogo
